import {useLocation} from "react-router-dom";
import Item from "./Item";
import {itemIsActive} from "../../utils/itemIsActive";

export default function SectionsItem(props) {
  const {label = 'Предметы', activeFor = ['/sections', '/section', '/report', '/appeals', '/solutions']} = props;
  const url = useLocation();

  return (
    <Item
      link={'/sections'}
      label={label}
      active={itemIsActive(url.pathname, activeFor)}
    />
  );
}